import { render, staticRenderFns } from "./DashboardMichael.vue?vue&type=template&id=a18b3dd0&scoped=true&"
import script from "./DashboardMichael.vue?vue&type=script&lang=js&"
export * from "./DashboardMichael.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMichael.vue?vue&type=style&index=0&id=a18b3dd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18b3dd0",
  null
  
)

export default component.exports